"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var workflow_designer_process_model_1 = require("./workflow-designer-process.model");
var workflow_designer_point_matrix_model_1 = require("./workflow-designer-point-matrix.model");
var workflow_designer_gizmo_model_1 = require("./workflow-designer-gizmo.model");
var workflow_designer_workarea_model_1 = require("./workflow-designer-workarea.model");
var workflow_designer_miniview_model_1 = require("./workflow-designer-miniview.model");
var WorkflowDesignerViewportModel = /** @class */ (function () {
    function WorkflowDesignerViewportModel() {
        this.mouseDown = false;
        this.x = 0;
        this.y = 0;
        this.width = 500;
        this.height = 500;
        this._zoom = 1;
        this.process = new workflow_designer_process_model_1.WorkflowDesignerProcessModel();
        this._dragging = null;
        this.moved = false;
        this.resizeEnabled = false;
        this.zoomEnabled = true;
        this.scrollZoomEnabled = false;
        this.showGrid = true;
        this.snapToGrid = true;
        this.viewMode = false;
        this.cursorX = 0;
        this.cursorY = 0;
        this.selected = null;
        this.matrix = workflow_designer_point_matrix_model_1.WorkflowDesignerPointsMatrix;
        this.gizmo = new workflow_designer_gizmo_model_1.WorkflowDesignerGizmoModel();
        this.workarea = new workflow_designer_workarea_model_1.WorkflowDesignerWorkareaModel(this);
        this.miniview = new workflow_designer_miniview_model_1.WorkflowDesignerMiniviewModel(this);
    }
    Object.defineProperty(WorkflowDesignerViewportModel.prototype, "zoom", {
        get: function () {
            return this.zoomEnabled ? this._zoom : 1;
        },
        set: function (value) {
            value = value < 0.5 ? 0.5 : (value > 2 ? 2 : value);
            var w = this.width / 2;
            var h = this.height / 2;
            this.x = (this.x - w) / this.zoom * value + w;
            this.y = (this.y - h) / this.zoom * value + h;
            this._zoom = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkflowDesignerViewportModel.prototype, "centerX", {
        get: function () {
            return this.width / 2 / this.zoom - this.x / this.zoom;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkflowDesignerViewportModel.prototype, "centerY", {
        get: function () {
            return this.height / 2 / this.zoom - this.y / this.zoom;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkflowDesignerViewportModel.prototype, "transform", {
        get: function () {
            return "translate(" + this.x + " " + this.y + ") scale(" + this.zoom + " " + this.zoom + ")";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WorkflowDesignerViewportModel.prototype, "dragging", {
        get: function () {
            return this._dragging;
        },
        enumerable: true,
        configurable: true
    });
    WorkflowDesignerViewportModel.prototype.move = function (x, y) {
        this.x += x;
        this.y += y;
    };
    WorkflowDesignerViewportModel.prototype.drag = function (object, drag, select) {
        var _this = this;
        if (drag === void 0) { drag = true; }
        if (select === void 0) { select = true; }
        if (this._dragging || this.viewMode) {
            return;
        }
        this.moved = false;
        if (drag) {
            this._dragging = object;
        }
        setTimeout(function () {
            if (object && _this.selected !== object) {
                _this.gizmo.hide();
            }
            if (select) {
                _this.selected = object;
            }
        });
    };
    WorkflowDesignerViewportModel.prototype.endDrag = function () {
        this.moved = false;
        this._dragging = null;
        this.mouseDown = false;
    };
    WorkflowDesignerViewportModel.prototype.calculateNearestStatePoint = function (x, y) {
        var _this = this;
        var max = 10000;
        var ret = null;
        this.process.states.forEach(function (state, stateIndex) {
            if (!state.start) {
                _this.matrix.forEach(function (matrix, matrixIndex) {
                    var x1 = state.x + state.width * matrix.x, y1 = state.y + state.height * matrix.y, distance = _this.distance(x, y, x1, y1);
                    if (distance < 25 && distance < max) {
                        max = distance;
                        ret = ret || {};
                        ret.stateIndex = stateIndex;
                        ret.matrixIndex = matrixIndex;
                        ret.x = x1;
                        ret.y = y1;
                    }
                });
            }
        });
        return ret;
    };
    WorkflowDesignerViewportModel.prototype.distance = function (x1, y1, x2, y2) {
        var x = x2 - x1, y = y2 - y1;
        return Math.sqrt(x * x + y * y);
    };
    WorkflowDesignerViewportModel.prototype.resetView = function () {
        this.x = 0 - this.workarea.left * this.zoom + 40 * this.zoom;
        this.y = 0 - this.workarea.top * this.zoom + 40 * this.zoom;
    };
    WorkflowDesignerViewportModel.prototype.getMetadata = function () {
        var meta = {};
        meta.showGrid = this.showGrid;
        meta.snapToGrid = this.snapToGrid;
        meta.x = this.x;
        meta.y = this.y;
        meta.zoom = this.zoom;
        meta.states = [];
        this.process.states.forEach(function (state) {
            meta.states.push({
                x: state.x,
                y: state.y,
                width: state.width,
                height: state.height
            });
        });
        meta.actions = [];
        this.process.actions.forEach(function (action) {
            meta.actions.push({
                beginOrigin: action.beginOrigin,
                endOrigin: action.endOrigin
            });
        });
        return meta;
    };
    WorkflowDesignerViewportModel.prototype.setMetadata = function (meta) {
        if (!meta || this.isEmpty(meta)) {
            return;
        }
        this.showGrid = !!meta.showGrid;
        this.snapToGrid = !!meta.snapToGrid;
        this.x = meta.x || 0;
        this.y = meta.y || 0;
        this.zoom = meta.zoom || 1;
        if (meta.states && meta.states.length) {
            this.process.states.forEach(function (state, index) {
                if (meta.states[index]) {
                    state.x = meta.states[index].x || 0;
                    state.y = meta.states[index].y || 0;
                    state.width = meta.states[index].width || state.width || 200;
                    state.height = meta.states[index].height || state.height || 42;
                }
            });
        }
        if (meta.actions && meta.actions.length) {
            this.process.actions.forEach(function (action, index) {
                if (meta.actions[index]) {
                    action.beginOrigin = meta.actions[index].beginOrigin;
                    action.endOrigin = meta.actions[index].endOrigin;
                }
            });
        }
    };
    WorkflowDesignerViewportModel.prototype.isEmpty = function (obj) {
        var key;
        for (key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    };
    return WorkflowDesignerViewportModel;
}());
exports.WorkflowDesignerViewportModel = WorkflowDesignerViewportModel;
//# sourceMappingURL=workflow-designer-viewport.model.js.map